import { useEffect } from "react"

const PhoenixUtil = {
  keyDownHandler: (e, callBack, keyCode) => {
    if (!e || !callBack || !keyCode) {
      return
    }

    if (Array.isArray(keyCode)) {
      if (keyCode.includes(e.keyCode)) {
        callBack(e.keyCode)
      }
    } else if (e.keyCode === keyCode) {
      e.preventDefault()
      callBack()
    }
  },
  // eslint-disable-next-line consistent-return
  getCookie: name => {
    if (typeof document !== "undefined") {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length > 1)
        return (
          parts
            .pop()
            .split(";")
            .shift() || ""
        )
    }
  },
  trapFocus: (e, parentRef, toFocusRef, toFocusElement) => {
    if (!e || !parentRef) {
      return
    }

    if (!parentRef.current.contains(e.relatedTarget)) {
      if (toFocusRef) {
        toFocusRef.current.focus()
      } else if (toFocusElement) {
        toFocusElement.focus()
      }
    }
  },
  outsideOfParent: (e, parentRef, callBack) => {
    if (!e || !parentRef) {
      return
    }

    if (!parentRef.current.contains(e.relatedTarget || e.target)) {
      callBack()
    }
  },
  /**
   * Waits for an element satisfying selector to exist, then resolves promise with the element.
   *
   * @param selector
   * @returns {Promise}
   */
  elementReady: selector => {
    return new Promise(resolve => {
      const el = document.querySelector(selector)
      if (el) {
        resolve(el)
      }
      new MutationObserver((mutationRecords, observer) => {
        // Query for elements matching the specified selector
        Array.from(document.querySelectorAll(selector)).forEach(element => {
          resolve(element)
          // Once we have resolved we don't need the observer anymore.
          observer.disconnect()
        })
      }).observe(document.documentElement, {
        childList: true,
        subtree: true,
      })
    })
  },
  isChinaDomainName: () => {
    if (typeof window !== "undefined") {
      return window.location.hostname.includes("airasia.cn")
    }
    return false
  },
  isLocalEnvironment: () => {
    return false
    // return (
    //   window &&
    //   (window.location.hostname.indexOf("local.airasia.com") > -1 ||
    //     window.location.hostname.indexOf("localhost") > -1 ||
    //     window.location.hostname.indexOf("local.airasia.cn") > -1)
    // )
  },
  validateEmail: email => {
    // eslint-disable-next-line max-len
    const reg = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return reg.test(String(email).toLowerCase())
  },
  /**
   * Hook that alerts clicks outside of the passed ref
   */
  useOutsideClickHandler: (ref, callback) => {
    useEffect(() => {
      /**
       * close passenger selection modal if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback()
        }
      }

      if (document != null)
        document.addEventListener("mousedown", handleClickOutside)
      return () => {
        if (document != null)
          document.removeEventListener("mousedown", handleClickOutside)
      }
    }, [callback, ref])
  },
  checkStringBoolean: val => {
    return val.toLowerCase() === "true"
  },
  getLocaleCode: localeString => {
    const localeArr = localeString.split("-")

    return localeArr[0]
  },
  get: (url, headers) => {
    if (typeof fetch !== "function") {
      return
    }

    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
        headers,
      })
        .then(response => {
          if (response.status === 200) {
            return response.json()
          }

          return reject(response)
        })
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  post: (url, headers, payload) => {
    if (typeof fetch !== "function") {
      return
    }

    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        headers,
      })
        .then(response => {
          if (response.status === 200) {
            return response.json()
          }

          return reject(response)
        })
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  postText: (url, headers, payload) => {
    if (typeof fetch !== "function") {
      return
    }

    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        headers,
      })
        .then(response => {
          if (response.status === 200) {
            return response.text()
          }

          return reject(response)
        })
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getBrowserInfo: () => {
    const ua = navigator.userAgent
    let tem
    let M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || []
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || []
      return `IE ${tem[1] || ""}`
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
      if (tem != null)
        return tem
          .slice(1)
          .join(" ")
          .replace("OPR", "Opera")
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"]
    // eslint-disable-next-line no-cond-assign
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
    return M.join(" ")
  },
  getScreenWidth: () => {
    return window.innerWidth
  },
}

export default PhoenixUtil
